import * as React from 'react';
import NumericInput from '../../../shared/numeric_input';
import CustomEvent from '../../../custom_event';

const DEFAULT_CURRENCY = 'USD';

class Input extends React.Component {
  static defaultProps = {
    currency: DEFAULT_CURRENCY,
  };

  componentDidUpdate() {
    // clear value on autoupdate
    const input = this.refs[this.props.name].refs.input;
    const event = CustomEvent('input', { bubbles: true });

    input.value = this.props.value || '';
    input.dispatchEvent(event);
  }

  render() {
    return (
      <NumericInput
        name={this.props.name}
        ref={this.props.name}
        defaultValue={this.props.defaultValue}
        placeholder={this.props.placeholder}
        onChange={this.props.onChange}
        className={this.props.className}
      />
    );
  }
}

class PriceRange extends React.Component {
  onClick = (event) => {
    event.preventDefault();
    this.props.onClick(event);
    return false;
  };

  onChange = (event) => {
    this.props.onChange(event);
  };

  render() {
    return (
      <div className="facet">
        <form>
          <div className="facet__heading">{I18n.t('js.shared.priceRange.label')}</div>
          <div className="input-group">
            <Input
              ref="min"
              name="price_min"
              defaultValue={this.props.price_min}
              currency={this.props.currency}
              value={this.props.price_min}
              placeholder={I18n.t('js.shared.priceRange.minPlaceholder')}
              onChange={this.onChange}
              className="input-group__input"
            />
            <Input
              ref="max"
              name="price_max"
              defaultValue={this.props.price_max}
              currency={this.props.currency}
              value={this.props.price_max}
              placeholder={I18n.t('js.shared.priceRange.maxPlaceholder')}
              onChange={this.onChange}
              className="input-group__input"
            />
            <button onClick={this.onClick} className="input-group__button size-80">
              <span className="fa fa-chevron-right" />
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default PriceRange;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/shared/price_range.jsx